import { Navigate, Route, Routes } from 'react-router-dom';

import { ConditionDetailView } from './EmergingResearch/ConditionDetailView';
import { ConditionMetricsList } from './ConditionMetricsList';
import { ConditionMetricsDetailView } from './ConditionMetricsDetailView';
import { EmergingResearch } from './EmergingResearch/EmergingResearch';

export const ConditionsRoutes = () => {
  return (
    <Routes>
      <Route path={``} key='conditions' element={<Navigate to='/metrics' />} />
      <Route
        path={`metrics`}
        key='conditions-metrics'
        element={<ConditionMetricsList />}
      />
      <Route
        path={`emerging-research`}
        key='conditions-emerging-research'
        element={<EmergingResearch />}
      />
      <Route
        path={`:condition`}
        key='conditions-detail'
        element={<ConditionDetailView />}
      />
      <Route
        path={`metrics/:condition`}
        key='conditions-metrics-detail'
        element={<ConditionMetricsDetailView />}
      />
    </Routes>
  );
};
